import React, { useEffect } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

import { makeStyles } from '@material-ui/core/styles';

import BalanceDetailWrapper from './BalanceDetailWrapper';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    cardWrapper: {
        margin: '10px auto',
        '& p': {
            marginBottom: theme.spacing(2)
        },
    },
    table: {
        width: '100%',
        '& td, & th': {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            lineHeight: '1.43',
            letterSpacing: '0.01071em',
        },
        '& tbody tr': {
            borderBottomColor: theme.palette.divider,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            '&:last-child': {
                borderBottom: 'none'
            },
        }
    },
    bordered: {
        borderBottomColor: theme.palette.divider,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
    },
    card: {
        backgroundColor: theme.palette.grey[100],
        '& .MuiCardContent-root': {
            padding: theme.spacing(1),
        }
    }
}));


const CoupleBalanceModal = (props) => {
    const {
        open,
        setOpen,
        couple,
    } = props;

    const [balance, setBalance] = React.useState({});

    useEffect(() => {
        if (!couple) { return; }
        new Promise((resolve, reject) => {
            let url = `/api/admin/balances/${couple.id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setBalance(result);
                    resolve();
                })
        });
    }, [couple]);

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="lg"
        >
            <DialogContent dividers>
                {balance.id !== undefined && <BalanceDetailWrapper balance={balance} />}
                {balance.id === undefined && (
                    <Box align="center">
                        <CircularProgress color="primary" />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CoupleBalanceModal;
